import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { getPipelineConfig, putPipelineConfig } from '../../api/pipelineConfig'
import useApiCall from '../../api/useApiCall'
import { ISaveError } from '../../types/error'
import LoadingSection from '../LoadingSection/LoadingSection'
import MonacoSection from '../MonacoSection/MonacoSection'

import styles from './configuration.module.scss'

function Configuration() {
    const { t } = useTranslation()

    const [{ data, loading }] = useApiCall(getPipelineConfig)

    const saveChanges = async (data: string) => {
        await putPipelineConfig(data).catch((error) => {
            const errorData = error.response?.data as ISaveError

            toast(`${t(errorData.error)}: ${t(errorData.invalidValue)}`, {
                type: 'error',
            })

            throw new Error()
        })
    }

    if (loading) {
        return <LoadingSection />
    }

    return (
        <main className={styles.configuration}>
            <MonacoSection
                title="config.yml"
                value={data || ''}
                handleSave={saveChanges}
                rawData={data || ''}
            />
        </main>
    )
}

export default Configuration
